import {
  Mail,
  MailOpen,
  MessageSquare,
  MousePointer,
  Reply,
  Send,
  ThumbsUp,
  UserCheck,
  UserPlus,
} from "lucide-react";
import LinkedinSquare from "@/assets/svg/Linkedin-square.svg";
import whatsappIcon from "@/assets/svg/whatsapp.svg";
import MailIconSvg from "@/assets/svg/mail.svg";

/**
 * message steps must use linkedin_message (Sent / Delivered / Read), not connection funnel.
 */
const LINKEDIN_MESSAGE_ACTIONS = new Set([
  "linkedin_sms",
  "message",
  "linkedin_message",
  "send_message",
]);

const LINKEDIN_CONNECT_ACTIONS = new Set(["connect", "linkedin_connect"]);

const LINKEDIN_LIKE_ACTIONS = new Set([
  "linkedin_like",
  "like_post",
  "post_like",
  "like_latest_post",
]);

export function getChannelStepsKey(channel, action) {
  if (channel === "linkedin" && LINKEDIN_CONNECT_ACTIONS.has(action)) {
    return "linkedin_connect";
  }
  if (channel === "linkedin" && LINKEDIN_LIKE_ACTIONS.has(action)) {
    return "linkedin_like";
  }
  if (channel === "linkedin" && LINKEDIN_MESSAGE_ACTIONS.has(action)) {
    return "linkedin_message";
  }
  return channel;
}

/**
 * Static step definitions per channel
 */
export const CHANNEL_STEPS = {
  email: [
    {
      key: "mail_sent_at",
      icon: Send,
      label: "Sent",
      pendingLabel: "Not sent",
    },
    {
      key: "mail_opened_at",
      icon: MailOpen,
      label: "Opened",
      pendingLabel: "Not opened",
    },
    {
      key: "mail_link_clicked_at",
      icon: MousePointer,
      label: "Clicked",
      pendingLabel: "Not clicked",
    },
    {
      key: "replied_at",
      icon: Reply,
      label: "Replied",
      pendingLabel: "Not replied",
    },
  ],
  linkedin: [
    {
      key: "connect_sent_at",
      icon: UserPlus,
      label: "Request Sent",
      pendingLabel: "Request not sent",
    },
    {
      key: "connected_at",
      icon: UserCheck,
      label: "Request Accepted",
      pendingLabel: "Request not accepted",
    },
    {
      key: "replied_at",
      icon: MessageSquare,
      label: "Messaged",
      pendingLabel: "Not messaged",
    },
  ],
  linkedin_connect: [
    {
      key: "connect_sent_at",
      icon: UserPlus,
      label: "Request Sent",
      pendingLabel: "Request not sent",
    },
    {
      key: "connected_at",
      icon: UserCheck,
      label: "Request Accepted",
      pendingLabel: "Request not accepted",
    },
  ],
  linkedin_message: [
    {
      key: "message_sent_at",
      icon: MessageSquare,
      label: "Sent",
      pendingLabel: "Not sent",
    },
    {
      key: "message_delivered_at",
      icon: Mail,
      label: "Delivered",
      pendingLabel: "Not delivered",
    },
    {
      key: "message_read_at",
      icon: MousePointer,
      label: "Read",
      pendingLabel: "Not read",
    },
    {
      key: "replied_at",
      icon: Reply,
      label: "Replied",
      pendingLabel: "Not replied",
    },
  ],
  linkedin_like: [
    {
      key: "post_engaged_at",
      icon: ThumbsUp,
      label: "Post liked",
      pendingLabel: "Post not liked",
    },
  ],
  whatsapp: [
    {
      key: "message_sent_at",
      icon: MessageSquare,
      label: "Sent",
      pendingLabel: "Not sent",
    },
    {
      key: "message_delivered_at",
      icon: Mail,
      label: "Delivered",
      pendingLabel: "Not delivered",
    },
    {
      key: "message_read_at",
      icon: MousePointer,
      label: "Read",
      pendingLabel: "Not read",
    },
    {
      key: "replied_at",
      icon: Reply,
      label: "Replied",
      pendingLabel: "Not replied",
    },
  ],
};

export const CHANNEL_OPEN_CONFIG = {
  email: {
    label: "Email",
    icon: <img src={MailIconSvg} alt="Email" width={16} height={16} />,
  },
  linkedin: {
    label: "LinkedIn",
    icon: <img src={LinkedinSquare} alt="LinkedIn" width={16} height={16} />,
  },
  whatsapp: {
    label: "WhatsApp",
    icon: <img src={whatsappIcon} alt="WhatsApp" width={16} height={16} />,
  },
};

export const activities = [
  { key: "mail_sent_at", altKey: "message_sent_at", label: "Sent", color: "bg-gray-50 text-gray-700 border-gray-200" },
  { key: "mail_opened_at", label: "Opened", color: "bg-blue-50 text-secondary border-blue-200" },
  { key: "mail_link_clicked_at", label: "Clicked", color: "bg-purple-50 text-purple-700 border-purple-200" },
  { key: "message_read_at", label: "Read", color: "bg-orange-50 text-orange-700 border-orange-200" },
  { key: "replied_at", label: "Replied", color: "bg-green-50 text-green-700 border-green-200" },
];
